export const config = {
  mcpResourceOrigin: process.env.REACT_APP_MCP_RESOURCE_ORIGIN || '',
  proxyServiceOrigin: process.env.REACT_APP_PROXY_SERVICE_ORIGIN || '',
  backendHosts: {
    restHost: process.env.REACT_APP_REST_HOST || '',
    restBookHost: process.env.REACT_APP_REST_BOOK_HOST || '',
    websocketHost: process.env.REACT_APP_WS_HOST || '',
  },
  showConsoleLogs: process.env.REACT_APP_SHOW_CONSOLE_LOGS === 'true',
  accessToPaymentWithLoyaltyCardBonuses:
    process.env.REACT_APP_SHOW_PAYMENT_LOYALTY_CARD_BONUSES === 'true',
  isMaxIntegrationBlocked:
    process.env.REACT_APP_BLOCK_MAX_INTEGRATION === 'true',
  // Микросервис документооборота, встраивается через iframe (us/10305).
  documentFlowHost: process.env.REACT_APP_DOCS_HOST || '',
  // Микросервис зарплаты, вкладка в редактировании пользователя (us/11483).
  // Задан только в .env.production: без адреса вкладка не показывается.
  salaryHost: process.env.REACT_APP_SALARY_HOST || '',
  // Мок КриптоПро для локальной разработки подписания на машинах без
  // CSP/плагина/сертификата. В окружениях стендов переменная не задаётся.
  isCryptoProMock: process.env.REACT_APP_CRYPTOPRO_MOCK === 'true',
  mode: process.env.MODE || '',
};
